import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions.js';
import { getRecentPayments } from '../../../lib/requests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

export function* getRecentPaymentsRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_RECENT_PAYMENTS_REQUEST);
    try {
      const response = yield call(getRecentPayments, request.payload);
      yield put(actions.getRecentPaymentsSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred while fetching recent payments';
      if (e.response && e.response.data) {
        errorMessage = e.response.data.message || e.response.data;
      }
      yield put(actions.getRecentPaymentsFailure(errorMessage));
      
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}